import React, { useState } from "react";
import { FaHome, FaEnvelope, FaWhatsapp, FaPhone, FaArrowRight } from "react-icons/fa";

const MobileSidebar = ({ whatsappNumber = "919573487504" }) => {
    const [open, setOpen] = useState(false);

    const whatsappUrl = `https://wa.me/${whatsappNumber}`;

    return (
        <>
            {/* <button className="ms-toggle-btn" onClick={() => setOpen(!open)}>
                <FaArrowRight />      </button>

            <div className={`ms-sidebar ${open ? "open" : ""}`}>
                <a href="/" className="ms-item ms-4">
                    <FaHome /> <span>Home</span>
                </a>
                <a href="/contact" className="ms-item ms-4">
                    <FaEnvelope /> <span>Enquiry</span>
                </a>
                <a href={whatsappUrl} className="ms-item ms-4" target="_blank" rel="noopener noreferrer">
                    <FaWhatsapp /> <span>WhatsApp</span>
                </a>
                <a href="tel:+919876543210" className="ms-item ms-4">
                    <FaPhone /> <span>Call Now</span>
                </a>
            </div> */}



            <div className="footer-nav d-lg-none d-flex justify-content-center"> {/* सिर्फ mobile में दिखेगा */}
                <a href="/" className="ms-item">
                    <FaHome /> <span>Home</span>
                </a>
                <a href="/contact" className="ms-item">
                    <FaEnvelope /> <span>Enquiry</span>
                </a>
                <a href={whatsappUrl} className="ms-item" target="_blank" rel="noopener noreferrer">
                    <FaWhatsapp /> <span>WhatsApp</span>
                </a>
                <a href="tel:+919573487504" className="ms-item">
                    <FaPhone /> <span>Call Now</span>
                </a>
            </div>
        </>
    );
};

export default MobileSidebar;
